import { yup } from '@framework/validation/initYup.ts';
import { fromPairs } from 'lodash';
import { FormBuilderMetaFlags } from '../../../../../validator/form-builder/flags/FormBuilderMetaFlags.ts';
import { type ICreateWidgetFormSchemaInput } from '../../../IWidgetType.ts';
import { getDatatypeOutputSchema } from '../../common/async-widgets/getDatatypeOutputSchema.ts';
import { asyncSelectWidgetObjectName } from './hooks/asyncSelectObjectName.ts';
import { type IAsyncSelectWidget } from './IAsyncSelectWidget.ts';

export function createAsyncSelectFormSchema(
  input: ICreateWidgetFormSchemaInput<IAsyncSelectWidget>,
) {
  const { widget } = input;

  const outputs = widget.outputs ?? [];

  const objectSchema = yup
    .object(
      fromPairs(
        outputs.map(output => [
          output.name,
          getDatatypeOutputSchema(output.type),
        ]),
      ),
    )
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipDefaultValue,
      FormBuilderMetaFlags.SkipValidationRules,
    );

  return {
    [widget.code]: yup.string().notRequired(),
    [asyncSelectWidgetObjectName(widget.code)]: objectSchema.notRequired(),
  };
}
